
/**
 * 清楚特效
 */
import Workflow from "../lib/Workflow";
let PathAnimationArr = [];
export function clear() {
    PathAnimationArr.forEach(p => {
        p.stop();
    })

    PathAnimationArr = [];
}




export function multiRoam(entity, list) {
    if (!list || list.length < 1) {
        return
    }
    var funs = [];
    for (let i = 0; i < list.length; i++) {
        funs.push({
            fun: createRoamPromise,
            delay: list[i].delay * 1000,
            params: { entity: entity, item: list[i] },
        });
    }

    var ws = new Workflow(funs);
    ws.runWorkflow();

}


function createRoamPromise(obj) {

    let entity = obj.entity;
    let positions = obj.item.data;
    let time = obj.item.time;
    let delay = obj.item.delay;//延迟

    return new Promise((resolve) => {

        var animation = new PathAnimation({
            delay: 0.1,
            entity: entity,
            positions: positions,
            speed: 100,
            sumTime: time,
            multiple: 1,
            height: 0,
            addHeight: 0,
            cameraType: "无",
            shadingType: "无",
            surface: true,
            cycle: false,
            endBack: () => {
                resolve();
            }
        });

        animation.start();

    });
}



/**
 * 蔓延效果
 * @param {*} entity 
 * @param {*} height 
 */
export function spreadEntity(entity, list, isBig, height = 0) {
    if (!list || list.length < 1) {
        return
    }
    // 1 2 3
    // 0 1 1 yc
    //--0
    //--
    var funs = [];
    for (let i = 0; i < list.length; i++) {
        funs.push({
            fun: createSpreadPromise,
            delay: list[i].delay * 1000,
            params: { entity: entity, item: list[i], height: height, isBig: isBig },
        });
    }

    let last = list[list.length - 1]
    funs.push({
        fun: createSpreadPromiseLast,
        delay: last.delay * 1000,
        params: { entity: entity, item: last, height: height },
    })
    var ws = new Workflow(funs);
    ws.runWorkflow();

}


//最后一次不要计算了
function createSpreadPromiseLast(obj) {
    let entity = obj.entity;
    let height = obj.height;
    let positionsB = obj.item.positions; //目标形状
    return new Promise((resolve) => {
        var polygonHierarchy = new Cesium.PolygonHierarchy(positionsB);
        let callbackProperty = new Cesium.CallbackProperty(() => {
            //console.log("我不计算了")
            return polygonHierarchy;
        }, false);
        // entity.attrPlot=entity.attrPlot ||{};
        // entity.attrPlot["edit_positions"]=positionsB;
        entity.polygon.hierarchy = callbackProperty;
        resolve();
    });
}

function createSpreadPromise(obj) {
    let entity = obj.entity;
    let height = obj.height;
    let isBig = obj.isBig;
    let time = obj.item.time || 1;//执行时间30ms---10000---2
    //let speed = 1 / 1000 * 30 / time;
    let speed = time / 1000;
    //speed = speed < 0.0001 ? 0.0001 : speed;
    return new Promise((resolve) => {
        let positionsA = entity.polygon.hierarchy.getValue().positions; //当前形状
        //let scale = 10 / 1000;//米
        let scale = 0;//起步价
        let bboxA = [];
        positionsA.push(positionsA[0]);
        for (let i = 0, len = positionsA.length; i < len; i++) {
            let cartesian = positionsA[i];
            var carto = Cesium.Cartographic.fromCartesian(cartesian);
            var x = Cesium.Math.toDegrees(carto.longitude);
            var y = Cesium.Math.toDegrees(carto.latitude);
            let p = [x, y];
            bboxA.push(p);
        }
        let polygonA = turf.polygon([bboxA]);

        //需要优化
        // let innerPoint = getRandomPointInPolygon(polygonA);

        // console.log(innerPoint);
        // console.log("innerPoint");

        let positionsB = obj.item.positions; //目标形状
        positionsB.push(positionsB[0]);
        let bboxB = [];
        for (let i = 0, len = positionsB.length; i < len; i++) {
            let cartesian = positionsB[i];
            var carto = Cesium.Cartographic.fromCartesian(cartesian);
            var x = Cesium.Math.toDegrees(carto.longitude);
            var y = Cesium.Math.toDegrees(carto.latitude);
            let p = [x, y];
            bboxB.push(p);
        }

        let polygonA_A = null;
        let polygonB = turf.polygon([bboxB]);



        let callbackProperty = new Cesium.CallbackProperty(() => {


            if (isBig) {
                scale += speed;
            }
            else {
                scale -= speed;
                console.log(scale)
            }
            //A放大
            // let scaledPolygon = turf.transformScale(polygonA, scale, {
            //     origin: [(bboxA[0][0] + bboxA[0][0]) / 2, (bboxA[0][1] + bboxA[0][1]) / 2] //sw/se/nw/ne/center/centroid)//[(bbox[0][0] + bbox[0][0]) / 2, (bbox[0][1] + bbox[0][1]) / 2]
            // });

            var scaledPolygon = turf.buffer(polygonA, scale, { units: 'kilometers' });
            let newPositions = [];
            var intersection = null;

            if (isBig) {
                intersection = turf.intersect(scaledPolygon, polygonB); //求交
            }
            else {
                intersection = turf.union(scaledPolygon, polygonB); //合并
            }
            // 遍历多边形
            for (let i = 0; i < intersection.geometry.coordinates[0].length; i++) {
                // 遍历节点
                intersection.geometry.coordinates[0][i].forEach((item) => {
                    newPositions.push(item);
                })
                newPositions.push(height);
            }


            polygonA_A = scaledPolygon;
            let cartesian3Arr = Cesium.Cartesian3.fromDegreesArrayHeights(newPositions);
            var polygonHierarchy = new Cesium.PolygonHierarchy(cartesian3Arr);
            return polygonHierarchy;
        }, false);


        entity.polygon.hierarchy = callbackProperty;

        // setTimeout(() => {
        //     resolve();
        // }, time * 1000);


        let indexTimer = setInterval(() => {

            if (polygonA_A) {
                if (isBig) {

                    //如果第一个对象完全包含第二个对象，则返回true 
                    let booleanContains = turf.booleanContains(polygonA_A, polygonB);
                    if (booleanContains) {
                        polygonA_A = null;
                        clearInterval(indexTimer)
                        console.log("放大了")
                        resolve();
                    }
                }
                else {
                    let booleanContains = turf.booleanContains(polygonB, polygonA_A);
                    if (booleanContains) {
                        polygonA_A = null;
                        clearInterval(indexTimer)
                        console.log("缩小了")
                        resolve();
                    }
                }
            }
        }, 40)

    });
}


// 检查点是否在多边形内部
function isPointInPolygon(point, polygon) {
    return turf.booleanPointInPolygon(point, polygon);
}

// 生成多边形内部的随机点
function getRandomPointInPolygon(polygon) {
    while (true) {
        const randomPointFeatureCollection = turf.randomPoint(1, { "bbox": turf.bbox(polygon) });
        const randomPoint = randomPointFeatureCollection.features[0].geometry.coordinates;
        if (isPointInPolygon(randomPoint, polygon)) {
            return randomPoint;
        }
    }
}


/**
 * 增长实体(目前只支持面)
 * @param {*} entity 
 * @param {*} positions 
 * @param {*} speed 
 * @param {*} height 
 */
export function growEntityCom(entity, positions, speed, height = 0) {

    // var scale = 0;
    // var material = new Cesium.PolyGradientMaterialProperty({
    //     center: new Cesium.CallbackProperty(() => {
    //         scale += speed;
    //         scale = scale >= 1.0 ? 0 : scale;
    //         return new Cesium.Cartesian2(scale, 0.5);
    //     }, false)
    // });
    // entity.polygon.material = material;


    let scale = 0;
    let bbox = [];
    for (var i = 0, len = positions.length; i < len; i++) {
        let cartesian = positions[i];
        var carto = Cesium.Cartographic.fromCartesian(cartesian);
        var x = Cesium.Math.toDegrees(carto.longitude);
        var y = Cesium.Math.toDegrees(carto.latitude);
        let p = [x, y];
        bbox.push(p);
    }

    let polygon = turf.polygon([bbox]);

    let callbackProperty = new Cesium.CallbackProperty(() => {

        scale += speed;
        if (scale >= 1) {
            scale = 1;
        }

        let scaledPolygon = turf.transformScale(polygon, scale, {
            origin: [(bbox[0][0] + bbox[0][0]) / 2, (bbox[0][1] + bbox[0][1]) / 2] //sw/se/nw/ne/center/centroid)
        });
        let newPositions = [];
        // 遍历多边形
        for (let i = 0; i < scaledPolygon.geometry.coordinates[0].length; i++) {
            // 遍历节点
            scaledPolygon.geometry.coordinates[0][i].forEach((item) => {
                newPositions.push(item);
            })
            newPositions.push(height);
        }
        let cartesian3Arr = Cesium.Cartesian3.fromDegreesArrayHeights(newPositions);
        var polygonHierarchy = new Cesium.PolygonHierarchy(cartesian3Arr);
        return polygonHierarchy;
    }, false);


    entity.polygon.hierarchy = callbackProperty;

}

/**
 * 闪烁特效(通用)
 * @param {*} entity 实体
 * @param {*} duration 持续时间
 */
export function blinkEntity(entity, duration) {
    var originalShow = entity.show; // 获取实体的原始显示状态

    var blinkEffect = setInterval(function () {
        entity.show = false;
        setTimeout(function () {
            entity.show = true;
        }, 500); // 闪烁间隔为500毫秒
    }, 1000); // 闪烁频率为每秒一次

    // 在持续时间结束后停止闪烁效果
    setTimeout(function () {
        clearInterval(blinkEffect);
        entity.show = originalShow;
    }, duration * 1000);
}

import PathAnimation from "../lib/PathAnimation"
//添加通用漫游
export function action_comRoam(entity, positions, time) {
    var animation = new PathAnimation({
        entity: entity,
        positions: positions,
        speed: 100,
        sumTime: time,
        multiple: 1,
        height: 0,
        addHeight: 0,
        cameraType: "无",
        shadingType: "无",
        surface: true,
        cycle: false,
    });

    animation.start();

    PathAnimationArr.push(animation);
}

/**
 * 隐藏特效
 * @param {*} entity 
 * @param {*} duration 
 */
export function comHide(entity, duration) {
    setTimeout(function () {
        viewer.entities.remove(entity);
    }, duration * 1000);
}